import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ConnectionStatus from '../debug/ConnectionStatus';
import { TouchFriendlyInput, TouchFriendlyForm } from '../common/TouchFriendlyFormInputs';
import { useScreenSize } from '../reports/MobileReportInteractions';

const Login: React.FC = () => {
  const [email, setEmail] = useState('dev@roiexteriors.com');
  const [password, setPassword] = useState('password123');
  const [loading, setLoading] = useState(false);
  const { isPortrait } = useScreenSize();
  
  const { login, error } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // For Netlify and static deployments, always use the demo credentials
      const isStaticDeployment = 
        window.location.hostname.includes('netlify.app') || 
        window.location.hostname.includes('github.io') ||
        window.location.hostname.includes('reporting.roiconstruction.com') ||
        process.env.REACT_APP_USE_MOCK_DATA === 'true' ||
        process.env.REACT_APP_NETLIFY === 'true';
      
      // If this is a Netlify deployment, bypass normal authentication
      if (isStaticDeployment) {
        console.log('Static deployment detected - bypassing real authentication');
        // Create a mock successful login for Netlify deployments
        localStorage.setItem('authToken', 'mock-auth-token-for-netlify');
        localStorage.setItem('user', JSON.stringify({
          id: '3',
          firstName: 'Demo',
          lastName: 'User',
          email: 'dev@roiexteriors.com',
          role: 'admin'
        }));
        navigate('/dashboard');
        return;
      }
      
      // Normal authentication flow for non-Netlify deployments
      const success = await login(email, password);
      if (success) {
        navigate('/dashboard');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 bg-white p-6 sm:p-10 rounded-lg shadow-md">
        <div>
          <img 
            src="https://roiconstruction.com/wp-content/uploads/2024/04/Marylands-Premier-Roofer-ROI-Construction-Roofing-Siding-Windows-Doors.png" 
            alt="ROI Exteriors Logo" 
            className="mx-auto h-16"
          />
          <h2 className="mt-6 text-center text-2xl sm:text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Access the ROI Exteriors Marketing Analytics Portal
          </p>
        </div>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}
        
        <TouchFriendlyForm onSubmit={handleSubmit} className="mt-6">
          <div className="space-y-4">
            <TouchFriendlyInput
              id="email-address"
              name="email"
              type="email"
              autoComplete="email"
              required
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email address"
              showLabel={false}
            />
            
            <TouchFriendlyInput
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              label="Password"
              showLabel={false}
            />
          </div>

          <div className="flex items-center justify-between mt-4">
            <div className="text-sm">
              <Link 
                to="/register" 
                className={`font-medium text-blue-600 hover:text-blue-500 ${!isPortrait ? 'text-base' : ''}`}
              >
                Don&apos;t have an account? Register
              </Link>
            </div>
          </div>

          <div className="mt-6">
            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center py-3 px-4 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors min-h-[48px] duration-150"
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
          
          {/* Only show demo credentials in development mode */}
          {process.env.NODE_ENV === 'development' && (
            <div className="mt-4 text-center text-sm text-gray-600">
              <p>Demo credentials:</p>
              <p>Email: dev@roiexteriors.com</p>
              <p>Password: password123</p>
            </div>
          )}
        </TouchFriendlyForm>

        {/* Show ConnectionStatus component in development mode */}
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-8">
            <ConnectionStatus />
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;